module.exports = __webpack_public_path__ + "static/media/VF-Master-Table-Prediction-Pierre-Velarde.a94c1555.mp4";